import React, { Component } from 'react';
import axios from 'axios';
import CommonFunctions from './CommonFunctions';
import VoiceTrainerMainPanel from './VoiceTrainerMainPanel';
import LearnPanel from './LearnPanel';
import TrainPanel from './TrainPanel';
import SettingsPanel from './SettingsPanel';
import DictionariesSettings from './DictionariesSettings';
import VoiceSettings from './VoiceSettings';
import TrainResult from './TrainResult';
import Help from './Help';
import './App.css';
//const md5 = require('js-md5');

function hashCode(s) {
	var hash = 0, i, chr;
	if (s.length === 0) return hash;
	for (i = 0; i < s.length; i++) {
		chr = s.charCodeAt(i);
		hash = ((hash << 5) - hash) + chr;
		hash |= 0; // Convert to 32bit integer.
	}
	return hash;
}

export default class VoiceTrainer extends Component {
	constructor(props) {
		super(props);
		this.phrases = [];
		this.unselectedPhrases = [];
		this.enablePhrasesSelection = false;
		this.state = { mode: 'main', status: 'Loading' };

		window.onclick = (event) => {
				if (
						(!event.target.matches('#select-button')) &&
						(!event.target.matches('#select-menu a')) &&
						('mainPanel' in this) &&
						this.mainPanel !== null &&
						this.mainPanel.state.showSelectMenu)
					this.mainPanel.setState({ showSelectMenu: false });
			};

		window.onmouseup = () => { this.enablePhrasesSelection = false; };
	} // constructor

	componentDidMount() {
//		document.title = 'Voice trainer';
		document.addEventListener('keydown', this.onKeyDown.bind(this));
		this.loadDictionaries();
	}

	loadDictionaries() {
		this.phrases = [];
		let dictionaries = JSON.parse(
					CommonFunctions.getSetting('dictionaries',
						JSON.stringify(
							CommonFunctions.getDefaultDictionariesSettings())));

		dictionaries = dictionaries.filter(v =>
				(v.enabled && v.spreadsheetUrl !== ''));

		for (let i = 0; i < dictionaries.length; i++) {
			let d = dictionaries[i];
			let spreadsheetId = CommonFunctions.getSpreadsheetId(
					d.spreadsheetUrl);
			if (!spreadsheetId) {
				this.setState(
						{ status:
							'Can not determine the id of spreadsheet ' +
								d.spreadsheetUrl });
				return;
			}
			d.csvUrl = 'https://docs.google.com/spreadsheets/d/' +
					spreadsheetId + '/gviz/tq?tqx=out:csv';
		}

		let promises = dictionaries.map(d => axios.get(d.csvUrl));
		Promise.all(promises).then(
			(results) =>
			{
				for (let i = 0; i < results.length; i++) {
					let d = dictionaries[i];
					let phraseIndex =
							d.phraseColumn.charCodeAt(0) - 'A'.charCodeAt(0);
					let translationIndex =
							d.translationColumn.charCodeAt(0) -
							'A'.charCodeAt(0);

					let a = results[i].data.split('\n');
					if (d.skipFirstRow) a.shift();

					a = a
                        .map(v => CommonFunctions.csvToArray(v))
						.filter(v => (v && v.length))
						.map(v => {
							let r = ['', ''];
							if (phraseIndex < v.length) r[0] = v[phraseIndex];
							if (translationIndex < v.length)
								r[1] = v[translationIndex];
							return r;
						})
						.filter(v => v[0].length);

					this.phrases = this.phrases.concat(a);
				} // for (let i = 0; i < results.length; i++)
				this.getUnselectedPhrases();
				this.setState({ status: 'ready' });
			},
			error =>
			{
				this.setState({ status:
						error.message + '\nUrl:\n' + error.config.url });
			});
	} // loadDictioaries

	onKeyDown(event) {
		if (this.state.status !== 'ready') return;
//		console.log(event.key);
		if (this.state.mode === 'mainPanel') {
			if (event.key === 't') this.setState({ mode: 'train' });
		} else if (this.state.mode === 'train') {
			if ('trainPanel' in this) this.trainPanel.onKeyDown(event.key);
		}
 	}

	getUnselectedPhrases() {
		let hashes =
				CommonFunctions.getSetting('unselectedPhrases', '')
				.split(',')
				.map(v => parseInt(v, 10));
		this.unselectedPhrases =
				this.phrases
				.map(v => v[0])
				.filter(v => hashes.includes(hashCode(v)));
	}

	saveUnselectedPhrases() {
		/*
		let s = 'Check aaa bbb ccc fff ddd eee fff ggg hhh iii kkk lll mmm';
		console.log(hashCode(s));
		console.log(md5(s));
		console.log(md5.base64(s));
		console.log(md5(s).length);
		console.log(md5.base64(s).length);
		*/
	   CommonFunctions.saveSetting(
			   'unselectedPhrases',
			   this.unselectedPhrases.map(v => hashCode(v)).join(','));
	}

	render() {
		let content = false;

		if (this.state.status === 'ready') {

			if (this.state.mode === 'learn')
				content = <LearnPanel app={this} />;
			else if (this.state.mode === 'train')
				content = <TrainPanel
						app={this}
						ref={(r) => { this.trainPanel = r; }} />;
			else if (this.state.mode === 'trainResult')
				content = <TrainResult app={this} />;
			else if (this.state.mode === 'settings')
				content = <SettingsPanel app={this} />;
			else if (this.state.mode === 'dictionariesSettings')
				content = <DictionariesSettings app={this} />;
			else if (this.state.mode === 'voiceSettings')
				content = <VoiceSettings app={this} />;
			else if (this.state.mode === 'help')
				content = <Help app={this} />;
			else
				content = <VoiceTrainerMainPanel
						app={this}
						ref={(r) => { this.mainPanel = r; }} />;
// 				content = <DictionariesSettings app={this} />;

		} else if (this.state.status === 'Loading') {
			content =
				<div style={{ color: 'green',
			                  fontSize: 'x-large',
							  marginTop: 60 }}>
					The phrases are loading.
				</div>;

		} else {
			content =
				<div>

					<div style={{ color: 'red',
								  fontSize: 'x-large',
								  marginTop: 60 }}>
						<pre>{this.state.status}</pre>
					</div>

					<div style={{
								textAlign: 'right',
								position: 'absolute',
								bottom: 10,
								width: '90%' }}>
						<button onClick={() => {
									this.setState({ status: 'ready' });
								}}>
							Close
						</button>
					</div>
				</div>;
		}

		return (<div className="App">{content}</div>);
	} // render
} // class VoiceTrainer



// WEBPACK FOOTER //
// ./src/VoiceTrainer.js